(function() {
  function sanitize(value) {
    return value.replace(/[^A-Za-z0-9 ]/g, '').slice(0, 10);
  }

  function showMessage(text) {
    var msg = document.getElementById('collar-name-message');
    if (!msg) return;
    msg.textContent = text;
    msg.classList.add('is-visible');
    clearTimeout(msg._hideTimer);
    msg._hideTimer = setTimeout(function() {
      msg.classList.remove('is-visible');
      msg.textContent = '';
    }, 2500);
  }

  document.addEventListener('input', function(e) {
    if (e.target && e.target.id === 'collar-name') {
      var original = e.target.value;
      var cleaned = sanitize(original);
      if (cleaned !== original) {
        e.target.value = cleaned;
        e.target.dispatchEvent(new Event('input', { bubbles: true }));

        var hasInvalidChars = /[^A-Za-z0-9 ]/.test(original);
        var tooLong = original.replace(/[^A-Za-z0-9 ]/g, '').length > 10;

        if (hasInvalidChars && tooLong) {
          showMessage('Maximum 10 characters, no special characters.');
        } else if (hasInvalidChars) {
          showMessage('Only letters, numbers, and spaces allowed.');
        } else if (tooLong) {
          showMessage('Maximum 10 characters.');
        }
      }
    }
  }, true);

  document.addEventListener('paste', function(e) {
    if (e.target && e.target.id === 'collar-name') {
      e.preventDefault();
      var pasted = (e.clipboardData || window.clipboardData).getData('text');
      var combined = e.target.value + pasted;
      var cleaned = sanitize(combined);
      e.target.value = cleaned;
      e.target.dispatchEvent(new Event('input', { bubbles: true }));
      if (combined !== cleaned) {
        showMessage('Some characters were removed.');
      }
    }
  }, true);
})();